import { render, staticRenderFns } from "./ProductSoldReport.vue?vue&type=template&id=d215c13c&scoped=true"
import script from "./ProductSoldReport.vue?vue&type=script&lang=js"
export * from "./ProductSoldReport.vue?vue&type=script&lang=js"
import style0 from "./ProductSoldReport.vue?vue&type=style&index=0&id=d215c13c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d215c13c",
  null
  
)

export default component.exports